import { financeRefundRoles } from '@/utils/safariRefundAccess'

export default {
  path: '/finance',
  component: () => import('@/views/finance/Index'),
  redirect: { name: 'finance-efd-purchases' },
  children: [
    {
      path: 'refunds',
      component: () => import('@/views/finance/refunds/Layout'),
      children: [
        { path: '', name: 'finance-refunds', component: () => import('@/views/finance/refunds/List'), props: { queue: 'payment' }, meta: { title: 'Client refunds', roles: financeRefundRoles } },
        { path: 'completed', name: 'finance-refunds-completed', component: () => import('@/views/finance/refunds/List'), props: { queue: 'completed' }, meta: { title: 'Completed refunds', roles: financeRefundRoles } },
        { path: 'all', name: 'finance-refunds-all', component: () => import('@/views/finance/refunds/List'), meta: { title: 'All refund requests', roles: financeRefundRoles } }
      ]
    },
    {
      path: 'efd-purchases',
      component: () => import('@/views/finance/efd-purchases/Layout'),
      children: [
        {
          path: '',
          name: 'finance-efd-receipts',
          component: () => import('@/views/finance/efd-purchases/EFDReceipts'),
          meta: {
            title: 'EFD Purchases',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'vat-records',
          name: 'finance-vat-records',
          component: () => import('@/views/finance/efd-purchases/EFDVATRecords'),
          meta: {
            title: 'EFD Purchases',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'tra-records',
          name: 'finance-tra-records',
          component: () => import('@/views/finance/efd-purchases/EFDTRARecords'),
          meta: {
            title: 'EFD Purchases',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
          }
        }
      ]
    },
    {
      path: 'quick-payments',
      name: 'finance-quick-payments',
      component: () => import('@/views/finance/quick-payments/QuickPayments'),
      meta: {
        title: 'Quick payments',
        roles: ['general_manager']
      }
    },
    {
      path: 'pos-transactions',
      component: () => import('@/views/finance/pos-transactions/Layout'),
      children: [
        {
          path: '',
          name: 'finance-pos-transactions-pending',
          component: () => import('@/views/finance/pos-transactions/Transactions'),
          meta: {
            title: 'POS Transactions',
            roles: ['general_manager', 'finance_manager']
          }
        },
        {
          path: 'imports',
          name: 'finance-pos-transactions-imports',
          component: () => import('@/views/finance/pos-transactions/Imports'),
          meta: {
            title: 'POS Transactions',
            roles: ['general_manager', 'finance_manager']
          }
        },
      ]
    },
    {
      path: 'pos-transactions/imports/:id',
      name: 'finance-pos-transactions-imports-detail',
      component: () => import('@/views/finance/pos-transactions/ImportsDetail'),
      meta: {
        title: 'POS Transactions',
        roles: ['general_manager', 'finance_manager']
      }
    },
    {
      path: 'altura-reimbursement',
      component: () => import('@/views/finance/altura-reimbursement/Layout'),
      children: [
        {
          path: '',
          name: 'finance-altura-reimbursement-payments',
          component: () => import('@/views/finance/altura-reimbursement/Payments'),
          meta: {
            title: 'Altura Reimbursement',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: 'groups',
          name: 'finance-altura-reimbursement-groups',
          component: () => import('@/views/finance/altura-reimbursement/Groups'),
          meta: {
            title: 'Altura Reimbursement',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
      ]
    },
    {
      path: 'altura-reimbursement/:id',
      name: 'finance-altura-reimbursement-detail',
      component: () => import('@/views/finance/altura-reimbursement/Detail'),
      meta: {
        title: 'Altura Reimbursement',
        roles: ['general_manager', 'accountant_supervisor']
      }
    },
    {
      path: 'cashflow-reconciliation',
      component: () => import('@/views/finance/cashflow-reconciliation/Layout'),
      children: [
        {
          path: '',
          name: 'finance-cashflow-reconciliation-nmb',
          component: () => import('@/views/finance/cashflow-reconciliation/NMB'),
          meta: {
            title: 'Cashflow Reconciliation',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: 'equity',
          name: 'finance-cashflow-reconciliation-equity',
          component: () => import('@/views/finance/cashflow-reconciliation/Equity'),
          meta: {
            title: 'Cashflow Reconciliation',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: 'wise',
          name: 'finance-cashflow-reconciliation-wise',
          component: () => import('@/views/finance/cashflow-reconciliation/Wise'),
          meta: {
            title: 'Cashflow Reconciliation',
            roles: ['general_manager']
          }
        },
        {
          path: 'kassa',
          name: 'finance-cashflow-reconciliation-kassa',
          component: () => import('@/views/finance/cashflow-reconciliation/Kassa'),
          meta: {
            title: 'Cashflow Reconciliation',
            roles: ['general_manager']
          }
        },
        {
          path: 'stripe',
          name: 'finance-cashflow-reconciliation-stripe',
          component: () => import('@/views/finance/cashflow-reconciliation/Stripe'),
          meta: {
            title: 'Cashflow Reconciliation',
            roles: ['general_manager']
          }
        },
        {
          path: 'rule-engine',
          name: 'finance-cashflow-reconciliation-rule',
          component: () => import('@/views/finance/cashflow-reconciliation/RuleEngine'),
          meta: {
            title: 'Cashflow Reconciliation',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'taxes',
      component: () => import('@/views/finance/taxes/Layout'),
      children: [
        {
          path: '',
          name: 'finance-taxes',
          component: () => import('@/views/finance/taxes/taxes/List'),
          meta: {
            title: 'Taxes',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: 'vat-statement',
          name: 'finance-taxes-vat',
          component: () => import('@/views/finance/taxes/vat/List'),
          meta: {
            title: 'VAT statement',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
      ]
    },
    {
      path: 'taxes/:id',
      name: 'finance-taxes-detail',
      component: () => import('@/views/finance/taxes/taxes/Detail'),
      meta: {
        title: 'Taxes',
        roles: ['general_manager', 'accountant_supervisor']
      }
    },
    {
      path: 'taxes/vat-statement/:id',
      name: 'finance-taxes-vat-statement-detail',
      component: () => import('@/views/finance/taxes/vat/Detail'),
      meta: {
        title: 'VAT statement',
        roles: ['general_manager', 'accountant_supervisor']
      }
    },
    {
      path: 'analytics',
      name: 'finance-analytics',
      component: () => import('@/views/finance/analytics/Analytics'),
      meta: {
        title: 'Finance analytics',
        roles: ['general_manager']
      }
    },
    {
      path: 'cashflow',
      name: 'finance-cashflow',
      component: () => import('@/views/finance/cashflow/Cashflow'),
      meta: {
        title: 'Finance cashflow',
        roles: ['general_manager', 'accountant_supervisor', 'operations_supervisor', 'finance_manager']
      }
    },
    {
      path: 'on-site-payments',
      component: () => import('@/views/finance/on-site/Index'),
      children: [
        {
          path: '',
          name: 'finance-onsite-payments',
          component: () => import('@/views/finance/on-site/List'),
          meta: {
            title: 'On-Site Payments',
            roles: ['general_manager']
          }
        },
        {
          path: ':id',
          name: 'finance-onsite-payments-detail',
          component: () => import('@/views/finance/on-site/Detail'),
          meta: {
            title: 'On-Site Payments',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'efd-sales',
      component: () => import('@/views/finance/efd-sales/Layout'),
      children: [
        {
          path: '',
          name: 'finance-efd-sales',
          component: () => import('@/views/finance/efd-sales/Receipts'),
          meta: {
            title: 'Finance EFD Sales',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: 'custom',
          name: 'finance-efd-sales-custom',
          component: () => import('@/views/finance/efd-sales/Custom'),
          meta: {
            title: 'Finance EFD Sales',
            roles: ['general_manager', 'accountant_supervisor']
          }
        },
        {
          path: 'invoices',
          name: 'finance-efd-sales-invoices',
          component: () => import('@/views/finance/efd-sales/Invoices'),
          meta: {
            title: 'Finance EFD Sales',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'dictionaries',
      component: () => import('@/views/finance/dictionaries/Layout'),
      children: [
        {
          path: '',
          name: 'finance-dictionaries-banks',
          component: () => import('@/views/finance/dictionaries/Banks'),
          meta: {
            title: 'Finance dictionaries',
            roles: ['general_manager']
          }
        },
        {
          path: 'transaction-items',
          name: 'finance-dictionaries-items',
          component: () => import('@/views/finance/dictionaries/TransactionItems'),
          meta: {
            title: 'Finance dictionaries',
            roles: ['general_manager']
          }
        },
        {
          path: 'transaction-item-groups',
          name: 'finance-dictionaries-item-groups',
          component: () => import('@/views/finance/dictionaries/TransactionItemGroups'),
          meta: {
            title: 'Finance dictionaries',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'fund-requests',
      component: () => import('@/views/finance/fund-requests/Layout'),
      children: [
        {
          path: '',
          name: 'finance-fund-requests-active',
          component: () => import('@/views/finance/fund-requests/Active'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        },
        {
          path: 'completed',
          name: 'finance-fund-requests-completed',
          component: () => import('@/views/finance/fund-requests/Completed'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        },
        {
          path: 'rejected',
          name: 'finance-fund-requests-rejected',
          component: () => import('@/views/finance/fund-requests/Rejected'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        }
      ]
    },
    {
      path: 'fund-requests/:id',
      component: () => import('@/views/finance/fund-requests/detail/Layout'),
      children: [
        {
          path: '',
          name: 'finance-fund-requests-detail-items',
          component: () => import('@/views/finance/fund-requests/detail/Items'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        },
        {
          path: 'invoices',
          name: 'finance-fund-requests-detail-invoices',
          component: () => import('@/views/finance/fund-requests/detail/Invoices'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        },
        {
          path: 'cashflow',
          name: 'finance-fund-requests-detail-cashflow',
          component: () => import('@/views/finance/fund-requests/detail/Cashflow'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        },
        {
          path: 'efd-receipts',
          name: 'finance-fund-requests-detail-receipts',
          component: () => import('@/views/finance/fund-requests/detail/Receipts'),
          meta: {
            title: 'Fund requests',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager', 'transfer_supervisor']
          }
        }
      ]
    },
    {
      path: 'supplier-invoices',
      component: () => import('@/views/finance/supplier-invoices/Layout'),
      children: [
        {
          path: '',
          name: 'finance-supplier-invoices',
          component: () => import('@/views/finance/supplier-invoices/Invoices'),
          meta: {
            title: 'Supplier invoices',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
          }
        },
        {
          path: 'payment-plan',
          name: 'finance-supplier-invoices-payment-plan',
          component: () => import('@/views/finance/supplier-invoices/PaymentPlan'),
          meta: {
            title: 'Supplier invoices',
            roles: ['general_manager', 'accountant_supervisor', 'accountant_manager']
          }
        },
      ]
    },
  ]
}
